const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    type_id: {
      type: 'string',
      title: 'نوع',
      oneOf: [
        { const: 1, title: 'active' },
        { const: 0, title: 'inactive' },
      ],
    },
    conditions: {
      type: 'string',
      title: 'شرایط',
    },
  },
});

export default schema;
